const Flickity = require('flickity');
export function carousel() {
  const carousel = document.querySelectorAll('.js-carousel');
  if(carousel) {
    for (let i = 0; i < carousel.length; i++) {
      const el = carousel[i];
      new Flickity(el, {
        cellSelector: '.js-carousel-cell',
        cellAlign: 'left',
        wrapAround: true,
        groupCells: true,
        setGallerySize: false,
        prevNextButtons: true,
        pageDots: true,
        pauseAutoPlayOnHover: false,
        arrowShape: {
          x0: 30,
          x1: 60,
          y1: 30,
          x2: 65,
          y2: 30,
          x3: 35
        }
      });
    }
  }
}